/* Hada Labo: keep visitors in their language (sl/en). Runs before paint. */
(function () {
  try {
    if (!window.Shopify || !Shopify.routes) return;
    var root = Shopify.routes.root;               // "/" (en) or "/sl/"
    if (root !== '/' && root !== '/sl/') return;  // other markets: do nothing
    var cur = root === '/sl/' ? 'sl' : 'en';
    var KEY = 'hl_lang', SEEN = 'hl_seen';
    var saved = null; try { saved = localStorage.getItem(KEY); } catch (e) {}
    var seen = false; try { seen = sessionStorage.getItem(SEEN) === '1'; } catch (e) {}
    if (seen) { try { localStorage.setItem(KEY, cur); } catch (e) {} return; } // navigating: current = preference
    try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    var pref = saved;
    if (!pref) {
      var nav = (navigator.languages && navigator.languages[0]) || navigator.language || '';
      pref = /^sl/i.test(nav) ? 'sl' : cur;
    }
    try { localStorage.setItem(KEY, pref); } catch (e) {}
    if (pref === cur) return;
    var p = location.pathname, target;
    if (pref === 'sl') target = '/sl' + (p === '/' ? '' : p);
    else target = p.replace(/^\/sl(\/|$)/, '/');
    if (!target) target = '/';
    if (target !== p) location.replace(target + location.search + location.hash);
  } catch (e) {}
})();

/* HL: stil za Shopify cookie baner (assets/hl-cookie-banner.css), Claude 26.09. */
(function () {
  try {
    var s = document.currentScript && document.currentScript.src;
    if (!s || document.getElementById('hl-cookie-css')) return;
    var l = document.createElement('link');
    l.id = 'hl-cookie-css';
    l.rel = 'stylesheet';
    l.href = s.replace(/hl-locale\.js(\?.*)?$/, 'hl-cookie-banner.css');
    document.head.appendChild(l);
  } catch (e) {}
})();
